import { RNTRC_DATA_WITH_UUID, NOT_FOUND_CUSTOM } from '@/constants';
import { HttpStatusCode, fromRiskBff, httpClient } from '@/utils';
import { DeepPartial } from '@/types';
import { NotFoundError, UnauthorizedError, UnprocessableEntity } from '../errors';
import { RNTRCByOwnerResponse } from './types';
import { valueOrEmptyString } from '@/utils/string';

const notFoundError = new NotFoundError(NOT_FOUND_CUSTOM);

const parseResult = (body: RNTRCByOwnerResponse): RNTRCByOwnerResponse['data'] => ({
  name: valueOrEmptyString(body?.data?.name),
  rntrcUuid: valueOrEmptyString(body?.data?.rntrcUuid),
  plate: valueOrEmptyString(body?.data?.plate),
  rntrc: valueOrEmptyString(body?.data?.rntrc),
  document: valueOrEmptyString(body?.data?.document),
  documentType: valueOrEmptyString(body?.data?.documentType),
});

export const loadRNTRCDataWithUUIDService = async (
  number: string,
): Promise<DeepPartial<RNTRCByOwnerResponse['data']>> => {
  const { body, status } = await httpClient.get<RNTRCByOwnerResponse>(fromRiskBff(RNTRC_DATA_WITH_UUID), {
    params: { number },
  });

  switch (status) {
    case HttpStatusCode.notFound:
      throw notFoundError;
    case HttpStatusCode.ok:
      return parseResult(body);
    case HttpStatusCode.unauthorized:
      throw new UnauthorizedError();
    case HttpStatusCode.unprocessableEntity:
      throw new UnprocessableEntity();

    default:
      throw notFoundError;
  }
};
